import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function Imprint() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Navbar />
      <main className="bg-slate-50 pb-16 pt-28 md:pb-20 md:pt-32">
        <div className="mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-10">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#0028CD]">
            Legal
          </p>
          <h1 className="mt-3 text-3xl font-bold tracking-tight text-[#0028CD] md:text-4xl">
            Imprint
          </h1>
          <p className="mt-4 max-w-3xl text-[15px] leading-relaxed text-slate-600">
            Legal notice and provider information in accordance with German regulations.
          </p>

          <div className="mt-8 space-y-4">
            <section className="rounded-2xl border border-[#0028CD]/15 bg-white p-5 md:p-6">
              <h2 className="text-lg font-semibold text-[#0028CD]">Company</h2>
              <div className="mt-3 space-y-1.5 text-[15px] leading-relaxed text-slate-700">
                <p>Industrial Digital Twin Applications GmbH (IDTA)</p>
                <p>Lyoner Straße 18</p>
                <p>60528 Frankfurt am Main</p>
                <p>Germany</p>
              </div>

              <div className="mt-5 grid gap-4 text-[15px] leading-relaxed text-slate-700 md:grid-cols-2">
                <div>
                  <p className="font-semibold text-slate-900">Contact</p>
                  <p>
                    E-mail:{' '}
                    <a href="mailto:info@idtwin.org" className="text-[#0028CD] hover:underline">
                      info@idtwin.org
                    </a>
                  </p>
                  <p>Phone: +49 151 5438 5054</p>
                </div>
                <div>
                  <p className="font-semibold text-slate-900">Commercial Register</p>
                  <p>Regulatory Authority: Amtsgericht Frankfurt am Main, HRB 138244</p>
                  <p>VAT ID (Section 27a UStG): DE453943742</p>
                  <p>Represented by: Meik Billmann</p>
                </div>
              </div>
            </section>

            <section className="rounded-2xl border border-[#0028CD]/15 bg-white p-5 md:p-6">
              <h2 className="text-lg font-semibold text-[#0028CD]">Address</h2>
              <div className="mt-3 space-y-1.5 text-[15px] leading-relaxed text-slate-700">
                <p>Industrial Digital Twin Applications GmbH (IDTA)</p>
                <p>Lyoner Street 18</p>
                <p>60528 Frankfurt am Main</p>
                <p>Germany</p>
              </div>
            </section>

            <section className="rounded-2xl border border-[#0028CD]/15 bg-white p-5 md:p-6">
              <h2 className="text-lg font-semibold text-[#0028CD]">Editorial Responsibility</h2>
              <ul className="mt-3 list-disc space-y-1.5 pl-5 text-[15px] leading-relaxed text-slate-700">
                <li>Meik Billmann</li>
              </ul>
              <p className="mt-4 text-[15px] leading-relaxed text-slate-700">
                This Legal Notice complies with the German laws under § 5 DDG and § 55 RStV.
              </p>
            </section>

            <section className="rounded-2xl border border-[#0028CD]/15 bg-white p-5 md:p-6">
              <h2 className="text-lg font-semibold text-[#0028CD]">Liability Notice</h2>
              <div className="mt-3 max-w-[75ch] space-y-3 text-[15px] leading-relaxed text-slate-700">
                <p>
                  For the topicality, correctness and completeness of the information provided in the Internet offer of the Industrial Digital Twin Applications GmbH (hereinafter referred to as “IDTA”) is not guaranteed. The Internet offer of the IDTA may contain references in the form of hyperlinks to Internet pages of third parties. The IDTA has no influence on the content of these external websites or the associated domains.
                </p>
                <p>
                  The respective providers or operators are responsible for both the content and the associated domains. The IDTA does not monitor the content of the linked websites. In the event that concrete legal violations become known, the corresponding links will be removed immediately. Data transmissions on the Internet, such as by e-mail, always involve a certain security risk.
                </p>
                <p>
                  Absolute protection of data against unauthorized access by third parties is not possible. The IDTA therefore draws attention to this security risk and advises careful use of means of communication. The IDTA opposes the use of any available contact information by a third party for sending unsolicited advertisements of any kind. In case of infringement, legal steps are expressly reserved.
                </p>
              </div>
            </section>

            <section className="rounded-2xl border border-[#0028CD]/15 bg-white p-5 md:p-6">
              <h2 className="text-lg font-semibold text-[#0028CD]">Image Material</h2>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-700">
                Own graphics
              </p>
            </section>

            <section className="rounded-2xl border border-[#0028CD]/15 bg-white p-5 md:p-6">
              <h2 className="text-lg font-semibold text-[#0028CD]">Editorial Department</h2>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-700">
                You can reach the online editorial team at{' '}
                <a href="mailto:info@idtwin.org" className="text-[#0028CD] hover:underline">
                  info@idtwin.org
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Imprint;
